
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getPrescriptionHTML } from '../Prescriptions/Templates/PrescriptionTemplates';

const PrescriptionPreviewModal = ({ show, onHide, templateId, lang, hospitalData }) => {
    // Dummy Data for Preview
    const dummyData = {
        patientData: {
            patientId: {
                firstName: "John",
                lastName: "Doe",
                age: 30,
                gender: "Male",
                mobile: "9876543210",
                patientId: "PID-2026-101"
            },
            name: "John Doe",
            age: 30,
            gender: "Male",
            mobile: "9876543210",
            ipdAdmissionId: "IPD-101"
        },
        hospitalData: {
            doctorId: {
                firstName: "Ajay",
                lastName: "Nigade",
                degree: "BAMS"
            }
        },
        checkedData: {
            diagnosis: "Viral Fever",
            billingDate: new Date().toISOString(),
            weight: "70 kg",
            bps: "120",
            bpd: "80",
            temp: "98.6 F",
            pulse: "72",
            complaint: "Fever and Headache",
            advice: "Drink plenty of water. Take rest."
        },
        medicines: [
            {
                medicineName: "Paracetamol 500mg",
                type: "TAB",
                dosage: "1",
                breakFastDose: "After",
                lunchDose: "-",
                dinnerDose: "After",
                days: "3",
                instruction: "Take after food"
            },
            {
                medicineName: "Vitamin C",
                type: "CAP",
                dosage: "1",
                breakFastDose: "After",
                lunchDose: "-",
                dinnerDose: "-",
                days: "5",
                instruction: "Chewable"
            }
        ],
        selectedDateTime: new Date()
    };

    const htmlContent = getPrescriptionHTML(templateId, { ...dummyData, lang, hospitalData });

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton closeVariant="white" style={{ background: 'var(--primary-color)', color: 'white' }}>
                <Modal.Title style={{ color: 'white' }}>Prescription Template {templateId} Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '75vh', padding: '20px', background: '#f5f5f5', display: 'flex', justifyContent: 'center' }}>
                <div style={{
                    width: '100%',
                    maxWidth: '800px',
                    height: '100%',
                    background: 'white',
                    boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
                    overflow: 'hidden',
                    borderRadius: '4px'
                }}>
                    <iframe
                        title="prescription-preview"
                        srcDoc={htmlContent}
                        style={{ width: '100%', height: '100%', border: 'none' }}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PrescriptionPreviewModal;
